<template>
  <div id="app">
    <img alt="Vue logo" src="./assets/logo.png">
    <infinite-table
      class="infinite-table"
      :data="theData"
      rowHeight="48"
      :header="header">
      </infinite-table>
  </div>
</template>

<script>
import InfiniteTable from 'vue-infinite-scroll-table'
let simpsonsData = require('./assets/simpsons.json')

export default {
  name: 'app',
  components: {
    InfiniteTable
  },
  data: () => ({
    theData: simpsonsData
  }),
  computed: {
    header () {
      let header = [
        { key: "Title", sortable: true, label: "Title", width: 200 },
        { key: "image_url", label: "Preview", type: 'image', width: 200 },
        { key: "IMDb Rating", sortable: true, label: "IMDb Rating", width: 200 },
        { key: "IMDb Votes", sortable: true, label: "IMDb Votes", width: 200 },
        { key: "# in Season", sortable: true, label: "# in Season", width: 200 },
        { key: "# in Series", sortable: true, label: "# in Series", width: 200 },
        { key: "Original Air Date", sortable: true, label: "Original Air Date", type: Date, width: 200 },
        { key: "Original Air Year", sortable: true, label: "Original Air Year", width: 200 },
        { key: "Production Code", sortable: true, label: "Production Code", width: 200 },
        { key: "Season", sortable: true, label: "Season", width: 200 },
        { key: "US Viewers(in millions)", sortable: true, label: "US Viewers(in millions)", width: 200 },
        { key: "Views", sortable: true, label: "Views" }
      ]
      return header
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.col {
  text-align: left;
}
</style>
